import api from './api';

const ENDPOINT = 'campaigns';

const CampaignService = {
  get: (params = null) => api.get(`${ENDPOINT}`, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  save: (data) => api.post(`${ENDPOINT}`, data),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
  copy: (id) => api.post(`${ENDPOINT}/${id}/copy`, {}),
};

export default CampaignService;
